/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { TradingPlansForDeletion } from '../models/trading-plans-for-deletion';
@Injectable({
  providedIn: 'root',
})
class TradingPlanService extends __BaseService {
  static readonly deleteTradingPlansPath = '/tradingPlan';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param tradingPlans undefined
   * @return delete the tradingPlan, response will be true if deleted successfully
   */
  deleteTradingPlansResponse(tradingPlans: TradingPlansForDeletion): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = tradingPlans;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/tradingPlan`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param tradingPlans undefined
   * @return delete the tradingPlan, response will be true if deleted successfully
   */
  deleteTradingPlans(tradingPlans: TradingPlansForDeletion): __Observable<boolean> {
    return this.deleteTradingPlansResponse(tradingPlans).pipe(
      __map(_r => _r.body as boolean)
    );
  }
}

module TradingPlanService {
}

export { TradingPlanService }
